export class UserLayer {
    ID: any;
    Title: string;
    Shared: boolean;
    Deletable: boolean;
}